import { isArray, isEmpty, trim, getByteLen, pullKeys, timeout } from '@/common/js/utils'
import { getSession, setSession } from '@/common/js/api'

import { callToAction } from '@/views/create/toutiao/data/enum'

import categroyData from '@/data/toutiao/ad_categroy'
import MCaption from '@/components/caption.vue'
import Category from '@/components/select/category.vue'
import AddTags from '@/components/add-tags.vue'
import Creative from '@/views/create/toutiao_local/components/idea/creative/creative.vue'
import Uploader from '@/views/create/toutiao_local/components/idea/uploader.vue'
import Document from '@/views/create/toutiao_local/components/idea/document/document.vue'
import CardCaption from '@/components/card-caption.vue'
import CardptomIcon from '@/components/cardptom/icon.vue'
import creativeData from '@/components/creative/creative-comp/creative-data.vue'
import cardPreview from '@/components/creative/creative-comp/card-preview.vue'

export default {
  components: { Category, AddTags, Creative, Uploader, MCaption, Document, CardCaption, CardptomIcon, creativeData, cardPreview },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    classes() {
      return (item) => {
        return ['m-creative-btn', { 'm-current': item.check }]
      }
    },
    titleLen() {
      if (this.idea && this.idea.title_list) {
        return this.idea.title_list.length
      } else {
        return 0
      }
    },
    pointLen() {
      if (this.idea && this.idea.promotion_card.product_selling_points) {
        return this.idea.promotion_card.product_selling_points.length
      } else {
        return 0
      }
    },
    statiAssemble() {
      return this.idea.creative_material_mode === 'STATIC_ASSEMBLE'
    },
    isAppDownLink() {
      return this.formItem.download_type === 'DOWNLOAD_URL' && this.formItem.app_type === 'APP_ANDROID'
    }
  },
  data() {
    return {
      categroyData: categroyData,
      creatCompModal: false, // 创意组件弹窗
      // 上传组件
      creativeWidth: '',
      creativeHeight: '',
      creativeMult: false, // 是否多选
      creativeModel: null, // 弹框是否显示
      creativeType: 'video', // 上传类型
      creativeSmart: '', // 智能封面

      callToAction: callToAction, // 行动号召枚举值

      // 选择文案
      docModel: null,
      // 多个创意
      creativeData: [],
      plan: {}
    }
  },
  watch: {
    // 创意分类
    'idea.mult_categroy': {
      handler(nVal) {
        if (nVal && nVal.length) {
          this.idea.third_industry_id = nVal[0].id
        }
      },
      deep: true
    }
  },
  methods: {
    pushWordIds(list, ids, title) {
      const arr = []
      let pos = -1
      if (isArray(ids)) {
        ids.forEach((ret, idx) => {
          const word = list.filter((meta) => meta.creative_word_id === ret)
          if (word.length) {
            pos = title.indexOf('{', pos)
            arr.push(...word)
            if (pos > -1) arr[idx].cut = pos
          }
        })
      }
      return arr
    },
    // 添加素材
    addCreative(type) {
      this.creativeSmart = ''
      this.creativeWidth = ''
      this.creativeHeight = ''
      this.creativeMult = true
      this.creativeType = type
      this.creativeModel = true
    },
    createMultipleCreative(list) {
      if (!isArray(list)) return
      const some = list.some(
        (ret) => !isArray(ret.items) || ret.items.some((t) => t.type === 'video' && (!isArray(t.video) || !isArray(t.cover)))
      )
      if (some) {
        this.$Message.error('上传的视频或封面错误')
        return
      }
      const multCreative = list.map((m) => {
        // 判断服务端错误
        if (isArray(m.items)) {
          if (this.creativeType === 'image' || this.creativeType === 'large') {
            const pop = m.items.pop()
            Object.assign(pop, { title: '', creative_word_ids: [] })
            return pop
          } else if (this.creativeType === 'group') {
            return { title: '', creative_word_ids: [], children: m.items }
          } else if (this.creativeType === 'video') {
            const pop = m.items.pop()
            const { video, cover } = pop
            return { title: '', creative_word_ids: [], children: [video.pop(), cover.pop()] }
          }
        }
      })
      this.idea[`${this.creativeType}Creative`].push(...multCreative)
      this.creativeModel = false // 关闭对话框
    },
    // 选择素材上传入口
    selectImage({ type, index }) {
      if (type === 'group' && isArray(index)) type = 'image'
      if (type === 'video' && isArray(index)) {
        const idx = index[0]
        // 智能封面依赖视频ID
        const videoItem = this.idea[`${type}Creative`][idx].children[0]
        if (videoItem.id || videoItem.video_id) this.creativeSmart = videoItem.id || videoItem.video_id
        type = 'large'
      } else this.creativeSmart = ''
      this.creativeWidth = ''
      this.creativeHeight = ''
      this.creativeMult = false
      this.creativeModel = true
      this.creativeType = type
      // 保存更新位置
      if (type === 'group' || type === 'video') {
        if (typeof index.index !== 'undefined') this.creativeIndex = index.index
      } else this.creativeIndex = index
    },
    // 删除选择框
    deleteItem({ type, index }) {
      this.idea[`${type}Creative`].splice(index, 1)
    },
    // 选完素材回调
    uploadFileHandler(list) {
      if (this.creativeMult) this.createMultipleCreative(list)
      else {
        let item
        // 判断服务端错误
        if (isArray(list)) {
          if (this.creativeType === 'image' || this.creativeType === 'large') {
            const pop = list.pop()
            if (isArray(this.creativeIndex)) {
              const [index, idx] = this.creativeIndex
              if (typeof idx === 'number') this.idea.groupCreative[index].children.splice(idx, 1, pop)
              else if (typeof idx === 'string') this.idea.videoCreative[index].children.splice(1, 1, pop)
            } else {
              item = Object.assign(this.idea[`${this.creativeType}Creative`][this.creativeIndex], pop)
              this.idea[`${this.creativeType}Creative`].splice(this.creativeIndex, 1, item)
            }
          } else if (this.creativeType === 'group') {
            item = Object.assign(this.idea[`${this.creativeType}Creative`][this.creativeIndex], { children: list })
            this.idea[`${this.creativeType}Creative`].splice(this.creativeIndex, 1, item)
          } else if (this.creativeType === 'video') {
            // 更新视频
            const pop = list.pop()
            this.idea.videoCreative[this.creativeIndex].children.splice(0, 1, pop)
          } else if (this.creativeType === 'logo') {
            // 卡片LOGO
            const pop = list.pop()
            if (pop) {
              pop.id = String(pop.id)
              const idx = list.findIndex((ret) => ret.id === pop.id)
              this.$set(this.idea, 'image_ids', pop.id)
              if (idx < 0) this.idea.creatives_detail.push(pop)
            }
          }
        } else if (list && list.type === 'video') {
          // 视频组
          const { video, cover } = list
          if (!isArray(video)) {
            this.$Message.error('上传视频时失败')
            this.creativeModel = false
            return
          } else if (!isArray(cover)) {
            this.$Message.error('上传封面时失败')
            this.creativeModel = false
            return
          }
          this.idea.videoCreative[this.creativeIndex].children = [video.pop(), cover.pop()]
        } else console.log('上传素材返回错误')

        // 关闭对话框
        this.creativeModel = false
      }
    },
    // 删除标签
    closeTag(name, data) {
      const index = this.idea[data].findIndex((ret) => ret === name)
      if (index > -1) this.idea[data].splice(index, 1)
    },
    // 增加标题
    addTitleList(ret) {
      let words = []
      const title = ret.docContent
      const creative_word_ids = ret.creativeWordIdsJson
      const val = typeof title === 'string' ? title : ''
      if (isArray(creative_word_ids)) words = this.pushWordIds(this.wordIds, creative_word_ids, title)
      this.idea.title_list.push({
        title: val,
        creative_word_ids: words
      })
    },
    // 删除标题
    delTitleList(index) {
      this.idea.title_list.splice(index, 1)
    },
    // 添加动态词
    appendTrend(params) {
      const { type, index, trend, direction } = params
      const meta = type === 'smart' ? this.idea.title_list : this.idea[`${type}Creative`]
      const len = meta[index].creative_word_ids.length
      const { title } = meta[index]
      if (len >= 2) {
        if (direction === 'left') {
          meta[index].creative_word_ids.shift()
          meta[index].creative_word_ids.unshift(trend)
        } else if (direction === 'right' || direction === 'plus-right') {
          if (direction === 'plus-right') trend.cut -= 4
          meta[index].creative_word_ids.pop()
          meta[index].creative_word_ids.push(trend)
        }
      } else if (len && direction === 'left') {
        meta[index].creative_word_ids.unshift(trend)
      } else {
        meta[index].creative_word_ids.push(trend)
      }
      meta[index].title = this.reflashTitle(title, meta[index].creative_word_ids, direction)
    },
    // 清除动态词
    deleteTrend(params) {
      const { type, index } = params
      const meta = type === 'smart' ? this.idea.title_list : this.idea[`${type}Creative`]
      meta[index].creative_word_ids = []
      meta[index].title = meta[index].title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
    },
    // 退格删除动态词
    delTrend(params) {
      const { type, index, order } = params
      const meta = type === 'smart' ? this.idea.title_list : this.idea[`${type}Creative`]
      // 2动态词 变1时，且是删除了左边动态词
      if (isArray(meta[index].creative_word_ids) && meta[index].creative_word_ids.length > 1 && order === 0) {
        const title = JSON.parse(JSON.stringify(meta[index].title))
        if (meta[index].creative_word_ids.length) {
          meta[index].creative_word_ids[1].cut = title.indexOf(`{${meta[index].creative_word_ids[1].name}}`)
        }
      }
      meta[index].creative_word_ids.splice(order, 1)
      meta[index].title = this.reflashTitle(meta[index].title, meta[index].creative_word_ids)
    },
    // 刷新标题
    reflashTitle(title, words, direction = 'left') {
      let newTitle
      if (words.length >= 2) {
        title = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
        const prefix = title.substring(0, words[0].cut)
        const midfix = direction === 'left' ? title.substring(words[0].cut, words[1].cut) : title.substring(words[0].cut, words[1].cut - 4)
        const suffix = direction === 'left' ? title.substring(words[1].cut) : title.substring(words[1].cut - 4)
        newTitle = `${prefix}{${words[0].name}}${midfix}{${words[1].name}}${suffix}`
      } else if (words.length) {
        title = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
        const prefix = title.substring(0, words[0].cut)
        const suffix = title.substring(words[0].cut)
        newTitle = `${prefix}{${words[0].name}}${suffix}`
      } else {
        newTitle = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
      }
      return newTitle
    },
    // 选择文案回调
    appendDocument(docs) {
      const len = this.idea.title_list.length
      if (docs.length > 10 - len) {
        const idx = docs.length - (10 - len)
        docs.splice(-idx, idx)
      }
      docs.forEach((ret) => {
        this.addTitleList(ret)
      })
      this.docModel = false
    },
    // 选择创意组件
    selectCreativeComp(val) {
      const { image_url, title, product_selling_points, button_text } = val.component_data
      const { component_id } = val
      this.formItem.creativeCompData = Object.assign({ image_url, title, product_selling_points, button_text })
      this.$set(this.formItem, 'component_id', component_id)
    },
    // 删除创意组件
    deleteCreateComp() {
      this.$set(this.formItem, 'component_id', '')
      this.formItem.creativeCompData = Object.assign({})
    },
    mergeCreative(ret) {
      const imageCreative = this.build('image', ret)
      const largeCreative = this.build('large', ret)
      const groupCreative = this.build('group', ret)
      const videoCreative = this.build('video', ret)
      return [...imageCreative, ...largeCreative, ...groupCreative, ...videoCreative]
    },
    build(type, ret) {
      const arr = []
      if (['image', 'large'].includes(type)) {
        ret[`${type}Creative`].forEach((ret) => {
          arr.push({
            image_mode: ret.image_mode,
            title: ret.title,
            creative_word_ids: ret.creative_word_ids.map((meta) => meta.creative_word_id),
            image_ids: [ret.id]
          })
        })
        return arr
      } else if (type === 'group') {
        ret[`${type}Creative`].forEach((ret) => {
          arr.push({
            image_mode: 'CREATIVE_IMAGE_MODE_GROUP',
            title: ret.title,
            creative_word_ids: ret.creative_word_ids.map((meta) => meta.creative_word_id),
            image_ids: ret.children.map((child) => child.id)
          })
        })
        return arr
      } else if (type === 'video') {
        ret[`${type}Creative`].forEach((ret) => {
          arr.push({
            image_mode: ret.children[0].image_mode,
            title: ret.title,
            creative_word_ids: ret.creative_word_ids.map((meta) => meta.creative_word_id),
            image_id: ret.children[1].id,
            video_id: ret.children[0].id,
            cover: ret.children[1].imageDetailId ? 1 : 0
          })
        })
        return arr
      }
    },
    addLandingPage() {
      this.idea.web_url_material_list.push('')
    },
    deleteLandingPage(index) {
      this.idea.web_url_material_list.splice(index, 1)
    },
    getVideoCount(list) {
      if (!isArray(list)) return 0
      const count = list.filter(
        (ret) => ret.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO' || ret.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
      ).length
      return count
    },
    getImageCount(list) {
      let imgCount = 0
      if (!isArray(list)) return 0
      const count = list.filter(
        (ret) => ret.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO' || ret.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
      ).length
      const imageList = list.filter((ret) =>
        [
          'CREATIVE_IMAGE_MODE_SMALL',
          'CREATIVE_IMAGE_MODE_LARGE',
          'CREATIVE_IMAGE_MODE_LARGE_VERTICAL',
          'CREATIVE_IMAGE_MODE_GROUP'
        ].includes(ret.image_mode)
      )
      imageList.forEach((ret) => {
        imgCount += ret.image_ids.length
      })
      return imgCount + count
    },
    validIdea() {
      const rules = [
        // {
        //   name: 'idea/app_name',
        //   require: true,
        //   min: 4,
        //   max: 20,
        //   desc: '应用名'
        // }
        // {
        //   name: 'idea/selling_points',
        //   require: true,
        //   min: 1,
        //   max: 10,
        //   desc: '产品卖点'
        // },
        // {
        //   name: 'idea/call_to_action_buttons',
        //   require: true,
        //   min: 1,
        //   max: 10,
        //   desc: '行动号召文案'
        // },
        // {
        //   name: 'idea/blue_flow_keywords',
        //   require: true,
        //   desc: '关键词'
        // },
        // {
        //   name: 'idea/image_ids',
        //   require: true,
        //   desc: '产品LOGO'
        // },
        // {
        //   name: 'idea/source',
        //   require: true,
        //   desc: '来源',
        //   relyon: 'formItem/landing_type',
        //   relyvalue: 'MICRO_GAME'
        // }
      ]
      return this.invalid(rules)
    },
    invalidPlus(ret, rules) {
      const arr = []
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? ret[rule.name.split('/')[0]][rule.name.split('/')[1]] : ret[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string') {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else {
          param = ruleName
          length = String(param).length
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? ret[rule.relyon.split('/')[0]][rule.relyon.split('/')[1]] : this.plan[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if ((rule.require && !param) || (rule.require && isEmpty(param))) {
          const msg = `${rule.desc}不能为空`
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (param && rule.max < length) {
          const msg = `${rule.desc}不能多于${rule.max}个字符`
          arr.push({ feild: rule.desc, msg })
          continue
        }
        if (param && rule.min > length) {
          const msg = `${rule.desc}不能少于${rule.min}个字符`
          arr.push({ feild: rule.desc, msg: rule.msg || msg })
          continue
        }

        // 正则
        if (rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    invalidExtand(ret) {
      const err = []
      const lenTitle = (val) => {
        let len = 0
        const regexp = /({[\u4e00-\u9fa5]{2,}})/g
        if (!isEmpty(val)) {
          const values = val.match(regexp)
          len += getByteLen(val)
          if (isArray(values)) {
            values.forEach((ret) => {
              ret === '{节日}' && (len += 4)
              ret === '{日期}' && (len += 6)
              ret === '{地点}' && (len += 2)
            })
          }
        }
        return len
      }
      const smallCreatives = ret.imageCreative // 小图
      const largeCreatives = ret.largeCreative
      const groupCreatives = ret.groupCreative
      const videoCreatives = ret.videoCreative

      // 非程序化创意
      if (ret.creative_material_mode === 'STATIC_CUSTOM' && (ret.creativeForm ? ret.creativeForm === 'AD' : true)) {
        const smallTitle = smallCreatives.some((met) => lenTitle(met.title) < 12 || lenTitle(met.title) > 60)
        if (smallTitle) {
          err.push({ feild: '小图素材创意标题', msg: '标题不能少于12或超过60个字符，请逐个检查' })
        }
        const largeTitle = largeCreatives.some((met) => lenTitle(met.title) < 12 || lenTitle(met.title) > 60)
        if (largeTitle) {
          err.push({ feild: '大图素材创意标题', msg: '标题不能少于12或超过60个字符，请逐个检查' })
        }
        const groupTitle = groupCreatives.some((met) => lenTitle(met.title) < 12 || lenTitle(met.title) > 60)
        if (groupTitle) {
          err.push({ feild: '组图素材创意标题', msg: '标题不能少于12或超过60个字符，请逐个检查' })
        }
        const videoTitle = videoCreatives.some((met) => lenTitle(met.title) < 12 || lenTitle(met.title) > 60)
        if (videoTitle) {
          err.push({ feild: '视频素材创意标题', msg: '标题不能少于12或超过60个字符，请逐个检查' })
        }
      }
      if (this.formItem.download_type === 'DOWNLOAD_URL' && (ret.creativeForm ? ret.creativeForm === 'AD' : true)) {
        if (!ret.app_name) {
          err.push({ feild: '应用名', msg: '应用名不能为空' })
        } else if (getByteLen(ret.app_name) < 4 || getByteLen(ret.app_name) > 20) {
          err.push({ feild: '应用名', msg: '应用名不能少于4或者大于20个字符' })
        }
      }
      if (ret.sub_title && getByteLen(ret.sub_title) > 24 && (ret.creativeForm ? ret.creativeForm === 'AD' : true)) {
        err.push({ feild: '副标题', msg: '副标题不能超过24个字符' })
      }
      // 图片未上传
      const smallImage = smallCreatives.some((met) => !met.id)
      const smallMsg = smallCreatives.some((met) => met.msg)
      if (smallImage) err.push({ feild: '小图素材', msg: '没有上传素材，不能提交' })
      if (smallMsg) err.push({ feild: '小图素材', msg: '上传的素材不符合规格，不能提交' })
      const largeImage = largeCreatives.some((met) => !met.id)
      const largeMsg = largeCreatives.some((met) => met.msg)
      if (largeImage) err.push({ feild: '大图素材', msg: '没有上传素材，不能提交' })
      if (largeMsg) err.push({ feild: '大图素材', msg: '上传的素材不符合规格，不能提交' })
      const groupImage = groupCreatives.some((met) => met.children.some((t) => !t.id))
      const groupMsg = groupCreatives.some((met) => met.children.some((t) => t.msg))
      if (groupImage) err.push({ feild: '组图素材', msg: '有一个或多个没有上传素材，不能提交' })
      if (groupMsg) err.push({ feild: '组图素材', msg: '上传的素材不符合规格，不能提交' })

      if (ret.creative_mode === 1) {
        const videoImage = videoCreatives.some((met) => met.children.some((t) => !t.id || !t.url))
        const videoMsg = videoCreatives.some((met) => met.children.some((t) => t.msg))
        if (videoImage) err.push({ feild: '视频素材', msg: '封面或者视频不能为空' })
        if (videoMsg) err.push({ feild: '视频素材', msg: '上传的封面或者视频不符合规格，不能提交' })
        const vertalImage = videoCreatives.some(
          (met) =>
            isArray(met.children[0].image_mode) &&
            met.children[0].image_mode.includes('VERTICAL') !== met.children[1].image_mode.includes('VERTICAL')
        )
        if (vertalImage) err.push({ feild: '视频素材', msg: '视频与封面必须同是横版或竖版' })
      }
      // 合并创意
      ret.creatives = this.mergeCreative(ret)

      // 判断媒体个数合法
      const videoCount = this.getVideoCount(ret.creatives)
      const imageCount = this.getImageCount(ret.creatives)

      if (videoCount > 10 || imageCount > 10) {
        err.push({ feild: '创意素材', msg: `提交的视频数：${videoCount}，图片数：${imageCount}，最多包含10张图和10个视频` })
      } else if (imageCount === 0 && videoCount === 0 && (ret.creativeForm ? ret.creativeForm === 'AD' : true)) {
        // 验证创意素材是否为空，新增是否有图文素材校验
        if (!ret.carousel_material_list?.length && ret.awemeIdentity !== 'AWEME_VIDEO') {
          err.push({ feild: '创意素材', msg: '提交的创意素材不能为空' })
        }
      }
      // 程序化标题长度
      if (ret.creative_material_mode === 'STATIC_ASSEMBLE') {
        const titleVaild = ret.title_list.some((met) => lenTitle(met.title) < 12 || lenTitle(met.title) > 60)
        const titleId = ret.title_list.some((met) => met.creative_word_ids && met.creative_word_ids.some((r) => !r))

        // 星广联投自动素材不需要验证文案
        if (titleVaild && !this.isStarTaskAutoMaterialEnable) {
          err.push({ feild: '创意标题', msg: '标题不能少于12或超过60个字符' })
        }
        if (titleId) {
          err.push({ feild: '创意标题', msg: '标题中含有动态词，动态词ID错误' })
        }
      }

      // 落地页校验
      if (ret.web_url_material_list.length && ret.web_url_material_list.some((ret) => isEmpty(ret))) {
        err.push({ feild: '落地页', msg: '落地页不能为空' })
      }

      // 预算与出价
      const deep_bid_type = this.formItem.delivery_setting.deep_bid_type
      const { bid_type, budget_optimize_switch } = this.formItem.delivery_setting
      const { ad_type, delivery_type, blue_flow_package } = this.formItem

      const { selling_points, call_to_action_buttons, blue_flow_keywords, image_ids, source, app_name } = ret
      if (ad_type === 'SEARCH' && delivery_type === 'NORMAL' && blue_flow_package.blue_flow_package_setting === 'ON') {
        if (!blue_flow_keywords) {
          err.push({ feild: '关键词', msg: '蓝海流量关键词不能为空' })
        }
      }

      if (ad_type === 'SEARCH' && delivery_type === 'DURATION') {
        const carousel_material_list_length = ret.carousel_material_list?.length || 0
        // imageCount 包含了图片和视频的个数
        if (imageCount + carousel_material_list_length < 3) {
          err.push({ feild: '创意素材', msg: '搜索广告极速智投最少需要3个视频加图片素材' })
        }

        // 极速智投不需要校验
      } else {
        if (!selling_points?.length) {
          err.push({ feild: '产品卖点', msg: '产品卖点不能为空' })
        }

        if (!call_to_action_buttons?.length) {
          err.push({ feild: '行动号召文案', msg: '行动号召文案不能为空' })
        }

        if (!image_ids) {
          err.push({ feild: '产品LOGO', msg: '产品LOGO不能为空' })
        }

        if (!app_name) {
          err.push({ feild: '应用名', msg: '应用名不能为空' })
        }
        if (!source && this.formItem.landing_type === 'MICRO_GAME') {
          err.push({ feild: '来源', msg: '来源不能为空' })
        }
      }

      if (ad_type === 'SEARCH') {
        if (delivery_type === 'NORMAL') {
          if (isEmpty(ret.budget) || ret.budget < 300 || ret.budget > 10000000) {
            err.push({ feild: '预算', msg: '预算不能为空，且出价范围需在300-9999999.99元之间' })
          }
        }

        // if (ret.budget <= this.formItem.delivery_setting.cpa_bid) {
        //   err.push({ feild: '预算', msg: '搜索广告预算必须大于项目出价' })
        // }

        const { text_abstract_list } = ret
        if (text_abstract_list.length > 10) {
          err.push({ feild: '文本摘要', msg: '最多添加10个文本摘要' })
        }

        for (let i = 0; i < text_abstract_list.length; i++) {
          const item = text_abstract_list[i]

          // getByteLen计算的是一个中文占两个字符，一个英文占一个字符，所以除以二
          const len = getByteLen(item) / 2
          if (len > 45 || len < 25) {
            err.push({
              feild: '文本摘要',
              msg: `第${i + 1}个文本摘要${len}个字符，最少25个字符，最多45个字符，一个中文占一个字符，两个英文占一个字符`
            })
          }
        }

        // delivery_type === 'DURATION' 不需要校验，同项目预算
      }
      if (ad_type === 'ALL' && this.formItem.delivery_mode === 'MANUAL') {
        // 竞价策略为最大转化，预算择优分配(CBO)开启时，不校验广告预算
        // 手动出价时才校验
        if (bid_type === 'NO_BID' && budget_optimize_switch === 'ON') {
        } else {
          if (isEmpty(ret.budget) || ret.budget < 300 || ret.budget > 10000000) {
            err.push({ feild: '预算', msg: '预算不能为空，且出价范围需在300-9999999.99元之间' })
          }
        }

        if (bid_type !== 'NO_BID') {
          if (isEmpty(ret.cpa_bid) || ret.cpa_bid < 0.1 || ret.cpa_bid > 10000) {
            err.push({ feild: '出价', msg: '出价不能为空，且出价范围需在0.1-10000元之间' })
          }

          if (deep_bid_type === 'DEEP_BID_MIN' && (isEmpty(ret.deep_cpabid) || ret.deep_cpabid < 0.1 || ret.deep_cpabid > 10000)) {
            err.push({ feild: '深度目标出价', msg: '深度优化出价不能为空，且出价范围需在0.1-10000元之间' })
          }

          if (deep_bid_type === 'ROI_COEFFICIENT' && (isEmpty(ret.roi_goal) || ret.roi_goal > 5)) {
            err.push({ feild: 'ROI系数', msg: 'ROI系数不能为空，且出价不大于5' })
          }
          if (ret.cpa_bid > ret.budget) err.push({ feild: '出价', msg: '出价不能大于预算值' })
        }
      }

      if (ret.awemeIdentity === 'AWEME' && !ret.aweme_id) err.push({ feild: '抖音号', msg: '抖音号不能为空' })
      if (ret.awemeIdentity === 'AWEME' && ret.anchor_related_type === 'SELECT' && !ret.anchor_id) {
        err.push({ feild: '锚点', msg: '锚点不能为空' })
      }
      // 选择抖音达人视频必选视频
      if (ret.awemeIdentity === 'AWEME_VIDEO' && !ret.aweme_video_list?.length) {
        err.push({ feild: '抖音达人视频', msg: '请点击勾选达人视频！' })
      }
      return err
    },
    submit() {
      const out_plan_info = getSession('outer_plan_params') || {}
      const plan_info = getSession('inner_plan_params') || {}
      const targetings = getSession('targetings') || []
      const batch_type = getSession('batch_task_type') || 1
      const convert_params = getSession('convert_params') || {}
      const campaign_ids = getSession('campaign_ids') || []
      const account_ids = getSession('ad_account_ids') || []

      const params = {
        outer_plan_params: out_plan_info,
        inner_plan_params: plan_info,
        targetings: targetings.map((ret) => {
          const param = [
            'audiences',
            'gender',
            'age',
            'city',
            'district',
            'interest_action_mode',
            'action_tags',
            'action_scene',
            'action_days',
            'action_categories',
            'action_words',
            'word_tags',
            'interest_categories',
            'interest_words',
            'location_type',
            'activate_type',
            'platform',
            'android_osv',
            'ios_osv',
            'carrier',
            'ac',
            'ad_tag',
            'tags',
            'device_brand',
            'device_type',
            'launch_price',
            'auto_extend_enabled',
            'auto_extend_targets',
            'article_category',
            'app_behavior_target',
            'app_category',
            'superior_popularity_type',
            'flow_package',
            'exclude_flow_package'
          ]
          out_plan_info.pricing === 'PRICING_OCPM' && param.push('hide_if_converted')
          this.formItem.isLive &&
            param.push(
              ...[
                'fan_tags',
                'aweme_talents',
                'aweme_fan_behaviors',
                'aweme_fan_time_scope',
                'aweme_fan_categories',
                'aweme_fan_accounts',
                'filter_aweme_abnormal_active',
                'filter_own_aweme_fans',
                'filter_aweme_fans_count'
              ]
            )
          ret.targetingParam = pullKeys(param, ret.targetingParam)
          return ret
        }),
        batch_task_type: parseInt(batch_type),
        convert_params: convert_params
      }

      // params.inner_plan_params.media_targeting_id = targetings.filter(m => m.targetingId).map(ret => ret.targetingId).join(',')

      if (params.batch_task_type === 1) params.campaign_ids = campaign_ids.map((ret) => ret.id).join(',')
      else params.ad_account_ids = account_ids.map((ret) => ret.id).join(',')

      // 多创意验证
      this.formErr = false
      this.errRes = []
      const customValids = this.customValid(this.creativeData)

      customValids.some((met, idx) => {
        if (met.err && met.err.length) {
          this.errRes = met.err
          this.index = idx
          return true
        }
      })
      if (this.errRes.length) {
        this.setIdea(this.index)
        this.formErr = true
        return // 如果错误中断
      }

      params.creative_params = this.creativeData.map((ret) => {
        ret.creatives = this.mergeCreative(ret)

        // 程序化创意
        if (ret.creative_material_mode === 'STATIC_ASSEMBLE') {
          ret = Object.assign(ret, {
            creative_material_mode: ret.creative_material_mode,
            image_list: ret.creatives,
            title_list: ret.title_list.map((ret) => {
              return {
                title: ret.title,
                creative_word_ids: ret.creative_word_ids.map((meta) => meta.creative_word_id)
              }
            }),
            creatives: []
          })
        }

        return pullKeys(
          [
            'ideaName',
            'inventory_type',
            'scene_inventory',
            'creative_display_mode',
            'image_mode',
            'image_list',
            'title_list',
            'app_name',
            'source',
            'ad_keywords',
            'third_industry_id',
            'web_url',
            'is_comment_disable',
            'close_video_detail',
            'creative_material_mode',
            'sub_title',
            'generate_derived_ad',
            'creatives',
            'creatives_detail'
          ],
          ret
        )
      })

      if (params) return

      setSession('creative_params', this.creativeData)
      this.$router.push({ name: 'localbatch' })
    },
    back() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>当前编辑数据未保存，返回将丢失编辑数据。</p><p>是否保存当前数据</p>',
        loading: true,
        okText: '是',
        cancelText: '否',
        onOk: () => {
          setSession('creative_params', this.creativeData)
          timeout(800).then(() => {
            this.$Modal.remove()
            this.$router.push({
              name: 'localplan',
              query: { t: 'edit' }
            })
          })
        },
        onCancel: () => {
          this.$router.push({
            name: 'localplan',
            query: { t: 'edit' }
          })
        }
      })
    },
    changePlayable() {
      this.idea.playable_url = ''
    },
    selectLogo() {
      this.creativeWidth = 108
      this.creativeHeight = 108
      this.creativeModel = true
      this.creativeType = 'logo'
    },
    preview(url) {
      window.open(url)
    }
  }
}
